import { Button } from '@mui/material';

type GenerateOrDownloadProps = {
  link: string | undefined;
  handler: () => void;
  handlerLabel?: string;
  linkLabel: string;
};

const GenerateOrDownload = ({ link, handler, handlerLabel, linkLabel }: GenerateOrDownloadProps) => {
  return link ? (
    <Button fullWidth href={link} variant="contained" target="new" color="warning" style={{ color: 'white' }}>
      {linkLabel}
    </Button>
  ) : (
    <Button fullWidth onClick={() => handler()} variant="contained">
      {handlerLabel}
    </Button>
  );
};

export default GenerateOrDownload;
